import { ChevronDown, GitBranch } from "lucide-react";
import { Label } from "../../../ui/label";
import { Skeleton } from "../../../ui/skeleton";

interface GitBranchItem {
  name: string;
  isDefault: boolean;
}

interface BranchPickerProps {
  branches: GitBranchItem[];
  value: string;
  onChange: (branch: string) => void;
  loading: boolean;
}

export function BranchPicker({ branches, value, onChange, loading }: BranchPickerProps) {
  return (
    <div className="space-y-1.5">
      <Label>Branch</Label>
      <div className="relative">
        <GitBranch className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground z-10" />
        {loading ? (
          <div className="h-9 pl-9 rounded-md bg-muted/30 flex items-center">
            <Skeleton className="h-3 w-24" />
          </div>
        ) : (
          <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full h-9 pl-9 pr-8 text-sm rounded-md bg-background appearance-none focus:outline-none focus:ring-2 focus:ring-ring cursor-pointer"
          >
            {branches.map((b) => (
              <option key={b.name} value={b.name}>
                {b.name}
                {b.isDefault ? " (default)" : ""}
              </option>
            ))}
            {branches.length === 0 && <option value={value}>{value}</option>}
          </select>
        )}
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground pointer-events-none" />
      </div>
    </div>
  );
}
